import {TBaseOrObservableType} from "../../index";
import {TComponentName} from "../../constants/ComponentRegistry";

interface IDialogDefinition {
    name: TComponentName // name of the dialog component
    params: IDialogOptions
}

interface IDialogOptions {
    content: any,
    doClose?: (() => void) | undefined
    fullWidth?: boolean | undefined
    id?: string | undefined
    isClosable?: KnockoutObservable<boolean> | undefined
    onError?: ((data?: any) => void) | undefined
    onSuccess?: ((data?: any) => void) | undefined
    title: TBaseOrObservableType<string>
    width?: string | undefined
}

interface IDialogOptionsComponent extends IDialogOptions {
    content: {
        name: TComponentName
        params: any & { dialog: IDialogOptions }
    }
}

interface IDialogOptionsConfirm extends IDialogOptions {
    content: string
    buttons?: {
        cancel?: boolean | IDialogButton
        confirm?: boolean | IDialogButton
    }
}

interface IDialogButton {
    cls?: string | undefined
    onClick?: Function | undefined
    label?: string | undefined
}
